import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { GridColumnMeta } from "./ant-grid-custom-model";
import { HttpClient } from "@angular/common/http";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { VAIconRegistryService, close } from "@va/core-library/icons";

@Component({
  selector: "app-ant-grid-custom",
  templateUrl: "./ant-grid-custom.component.html",
  styleUrls: ["./ant-grid-custom.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AntGridCustomComponent implements OnInit, OnChanges {
  @Input() dataToUse: any;
  @Input() resetSelection: boolean;
  @Output() paginationChange: EventEmitter<any> = new EventEmitter();
  @Output() selectedRows: EventEmitter<any> = new EventEmitter();
  @Output() sortChange: EventEmitter<any> = new EventEmitter();
  @Output() filterChange: EventEmitter<any> = new EventEmitter();

  columnsData: GridColumnMeta[];
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  isFrontPagination = false;
  listOfDisplayData: Array<any> = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  mapOfSort: { [key: string]: string | null } = {};
  listOfCheckedData: Array<any> = [];

  gridRowsData: any[] = [];
  fields: any[] = [];
  pageSize;
  pageIndex = 1;
  loading = false;
  isReportingPage = false;
  total = 0;
  gridSize = { y: "", x: "auto" };
  pageSizeOptions;
  sortName: string | null = null;
  sortValue: string | null = null;
  faSpinner = faSpinner;

  constructor(
    private http: HttpClient,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close]);
  }

  ngOnInit() {
    this.isFrontPagination =
      this.dataToUse.isFrontPagination !== undefined
        ? this.dataToUse.isFrontPagination
        : false;
    this.columnsData = this.dataToUse.columnsData;
    this.gridRowsData = this.dataToUse.processedData;
    this.fields = this.dataToUse.fields;
    for (const key of this.fields) {
      this.mapOfSort[key.field] = null;
    }
    this.gridSize = {
      x: this.dataToUse.gridWidth ? this.dataToUse.gridWidth : "auto",
      y: this.dataToUse.gridHeight,
    };
    this.pageSize = this.dataToUse.pageSize ? this.dataToUse.pageSize : 50;
    this.pageSizeOptions = this.dataToUse.pageSizeOptions
      ? this.dataToUse.pageSizeOptions
      : [10, 20, 30, 40, 50];
    this.isReportingPage = window.location.pathname
      .split("/")
      .includes("reporting");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataToUse) {
      if (this.gridRowsData !== this.dataToUse.processedData) {
        this.gridRowsData = this.dataToUse.processedData;
      }
      if (
        !changes.dataToUse.firstChange &&
        this.columnsData !== this.dataToUse.columnsData
      ) {
        this.columnsData = this.dataToUse.columnsData;
        this.fields = this.dataToUse.fields;
      }
      if (this.total !== this.dataToUse.totalCount) {
        this.total = this.dataToUse.totalCount;
      }
      if (this.listOfCheckedData.length === 0) {
        this.checkAll(false);
      }
      this.gridSize = {
        x: this.dataToUse.gridWidth ? this.dataToUse.gridWidth : "auto",
        y: this.dataToUse.gridHeight,
      };
      this.pageIndex = changes.dataToUse.currentValue.pageIndex;
      this.loading = false;
    }
    if (changes.resetSelection) {
      this.checkAll(false);
    }
  }

  onPaginationChange() {
    this.loading = true;
    this.paginationChange.emit([this.pageIndex, this.pageSize]);
    document.getElementsByClassName("ant-table-body")[0].scrollTo(0, 0); // TODO : change document later
  }

  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData
      .filter((item) => !item.selectionDisabled)
      .every((item) => this.mapOfCheckedId[item.id]);
    this.isIndeterminate =
      this.listOfDisplayData
        .filter((item) => !item.selectionDisabled)
        .some((item) => this.mapOfCheckedId[item.id]) &&
      !this.isAllDisplayDataChecked;
    this.listOfCheckedData = this.listOfDisplayData.filter(
      (item) => this.mapOfCheckedId[item.id],
    );
    this.selectedRows.emit([this.listOfCheckedData]);
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData
      .filter((item) => !item.selectionDisabled)
      .forEach((item) => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }

  // sort(sort: { key: string; value: string }): void {
  //   this.loading = true;
  //   this.sortChange.emit([sort]);
  // }

  sort(sortName: string, value: string): void {
    this.sortName = sortName;
    this.sortValue = value;
    for (const key in this.mapOfSort) {
      this.mapOfSort[key] = key === sortName ? value : null;
    }
    const sort = {
      key: this.sortName,
      value: this.sortValue,
    };
    this.sortChange.emit([sort]);
  }

  currentPageDataChange($event: Array<any>): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }
  filterApplied(event, col) {
    this.loading = true;
    let value = "";
    switch (col.filterType) {
      case "select":
        value = event;
        break;
      case "text":
        value = event.target.value;
        break;
      default:
        break;
    }
    this.filterChange.emit([value, col]);
  }
  resetFilter(col) {
    this.loading = true;
    col.currentValue = "";
    // (document.getElementsByName(col.sortKey)[0] as HTMLInputElement).value = "";
    this.filterChange.emit(["", col]);
  }

  resetAll() {
    this.sortName = null;
    this.sortValue = null;
    for (const key in this.mapOfSort) {
      this.mapOfSort[key] = null;
    }
    this.dataToUse.columnsData[0].forEach((col) => {
      // if (
      //   col.filterType === "text" &&
      //   col.showFilter &&
      //   document.getElementsByName(col.sortKey).length
      // ) {
      //   (document.getElementsByName(col.sortKey)[0] as HTMLInputElement).value =
      //     "";
      // }
      col.currentValue = "";
    });
  }

  isLoading() {
    this.loading = true;
  }
}
